import { FormActionHandlerService } from './base.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormDataService } from '../data.service';
import { FormEmailService } from '../email.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { formStatus } from '../../form.constants';
import { FormShareService } from '../share.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { events } from '../../../fastlane-common/event/event.constants';
import { dateTypes, contactType, incentiveProgram } from '../../../project/project.constants';
import { setStartoftheDayTime } from '../../../project/project.functions';
import * as i0 from "@angular/core";
import * as i1 from "../data.service";
import * as i2 from "../email.service";
import * as i3 from "../status.service";
import * as i4 from "../share.service";
import * as i5 from "../../../user/services/user-context.service";
import * as i6 from "../../../fastlane-common/services/swal.service";
import * as i7 from "../../../fastlane-common/services/publish-subscribe.service";
export class CompleteAuditActionHandlerService extends FormActionHandlerService {
    constructor(dataService, emailService, statusService, shareService, userContext, swal, pubSubService) {
        super();
        this.dataService = dataService;
        this.emailService = emailService;
        this.statusService = statusService;
        this.shareService = shareService;
        this.userContext = userContext;
        this.swal = swal;
        this.pubSubService = pubSubService;
    }
    exec() {
        const that = this;
        return new Promise((resolve, reject) => {
            that.swal.load('Submitting this form to LED for review...');
            // Change the status to received
            that.statusService.changeStatus(formStatus.received);
            // Add Verification Report Received Date
            that.dataService.addAuditFormDate(dateTypes.verificationReportReceivedDate, that.shareService.formId, that.userContext.currentUser.id);
            // Add Form Critical Date
            let swalTitle = 'Audit Submitted';
            if (that.shareService.currentIncentiveProgram === incentiveProgram.film.code) {
                swalTitle = 'Audit Submitted';
                const audit = that.shareService.form;
                audit.auditCriticalDates.verificationReportReceivedDate = setStartoftheDayTime(new Date());
            }
            if (that.shareService.currentIncentiveProgram === incentiveProgram.dm.code) {
                swalTitle = 'EVR Submitted';
                const audit = that.shareService.form;
                audit.auditCriticalDates.verificationReportReceivedDate = setStartoftheDayTime(new Date());
            }
            // Save the form and generate the pdf snapshot
            that.dataService.saveForm().subscribe(successfulSave => {
                that.raiseAuditCompleteEvent('');
                that.shareService.refreshPage();
                that.swal.success({
                    title: swalTitle,
                    text: 'The program manager has been notified'
                });
            }, errorSaving => reject('We were unable to submit your form to LED for review. Please try again later.'));
        });
    }
    raiseAuditCompleteEvent(auditingCompanyName) {
        const project = this.shareService.projectBase;
        const filmProject = project;
        const digitalProject = project;
        const form = this.shareService.auditInfo;
        // Select the one that is not null
        const entId = filmProject.projectInfo.filmId || digitalProject.projectInfo.digitalId;
        // Raise Event to notify of auditor change
        this.pubSubService.raise(events.auditManagementChange.code, formStatus.received, {
            eventType: events.auditManagementChange.code,
            eventAction: formStatus.auditorAssigned,
            data: {
                auditingCompanyName: auditingCompanyName,
                auditingCompanyId: form.auditingCompanyId,
                authorizedRepresentative: project.projectContacts.find(c => c.contactType === contactType.signee.code),
                auditForm: form,
                contacts: project.projectContacts,
                entertainmentIdType: project.projectInfo.incentiveProgram,
                entertainmentId: entId,
                incentiveProgram: project.projectInfo.incentiveProgram,
                projectGuid: project.id,
                projectId: project.projectInfo.projectId,
                projectInfoBase: project.projectInfo,
                projectName: project.projectInfo.projectName,
                season: form.season
            }
        });
    }
}
CompleteAuditActionHandlerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompleteAuditActionHandlerService_Factory() { return new CompleteAuditActionHandlerService(i0.ɵɵinject(i1.FormDataService), i0.ɵɵinject(i2.FormEmailService), i0.ɵɵinject(i3.FormStatusService), i0.ɵɵinject(i4.FormShareService), i0.ɵɵinject(i5.UserContextService), i0.ɵɵinject(i6.SwalService), i0.ɵɵinject(i7.PublishSubscribeService)); }, token: CompleteAuditActionHandlerService, providedIn: "root" });
